export default __webpack_public_path__ + "static/CSA_Cyber_Trust_Logo-02cca61de6ce14e048b7966dd82d49b3.png";